import { render, staticRenderFns } from "./LpProject.vue?vue&type=template&id=545ecf4c"
import script from "./LpProject.vue?vue&type=script&lang=js"
export * from "./LpProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports